var h = Object.defineProperty;
var c = (r, t, e) => t in r ? h(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var o = (r, t, e) => c(r, typeof t != "symbol" ? t + "" : t, e);
import { j as a } from "./path.js";
function l(r, t) {
  let e = r;
  for (const [n, i] of Object.entries(t))
    e = e.replace(`:${n}*`, () => i.toString()), e = e.replace(`:${n}`, () => encodeURIComponent(i.toString()));
  return e;
}
class s {
  constructor(t) {
    o(this, "config");
    this.config = {
      version: 1,
      prefix: "",
      method: "GET",
      origin: "",
      ...t
    };
  }
  get version() {
    return this.config.version ? `v${this.config.version}` : "";
  }
  get prefix() {
    return this.config.prefix;
  }
  get origin() {
    return this.config.origin;
  }
  get method() {
    return this.config.method;
  }
  getTemplateUrl() {
    return this.getJointUrl(this.config.pathname);
  }
  url(...t) {
    const { pathname: e } = this.config, n = this.hasParams() ? l(e, t[0]) : e;
    return this.getJointUrl(n);
  }
  getJointUrl(t) {
    return a(this.origin, this.prefix, this.version, t);
  }
  setOrigin(t) {
    return this.clone({ origin: t });
  }
  setVersion(t) {
    return this.clone({ version: t });
  }
  get() {
    return this.clone({ method: "GET" });
  }
  post() {
    return this.clone({ method: "POST" });
  }
  patch() {
    return this.clone({ method: "PATCH" });
  }
  delete() {
    return this.clone({ method: "DELETE" });
  }
  put() {
    return this.clone({ method: "PUT" });
  }
  hasParams() {
    return this.config.pathname.includes(":");
  }
  test(t) {
    const n = this.getTemplateUrl().replace(
      /:[\w*]+/g,
      (i) => i.endsWith("*") ? ".*" : "([^/]+)"
    );
    return new RegExp(`^${n}$`).test(t);
  }
  clone(t) {
    return new s({ ...this.config, ...t });
  }
}
export {
  s as E
};
//# sourceMappingURL=endpoint.js.map
